import { render, staticRenderFns } from "./ViewPresent.vue?vue&type=template&id=c35d930c&"
import script from "./ViewPresent.vue?vue&type=script&lang=js&"
export * from "./ViewPresent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports